import { createFileRoute } from "@tanstack/react-router";

import { TaxonomyPage } from "@/pages/TaxonomyPage";

export const Route = createFileRoute("/_app/(taxonomy)/taxonomy")({
  component: () => <TaxonomyPage />,
});
